export const useSxStyles = () => {
  const panelWidth = 350;

  return {
    panelWidth,

    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: '#fafafa',
      minHeight: 0,
      borderLeft: '1px solid rgba(0,0,0,0.06)',
      boxShadow: '-6px 0 16px rgba(0,0,0,0.06)',
    },

    header: {
      height: 44,
      px: 1.25,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#111',
      background: '#fafafa',
      borderBottom: '1px solid rgba(0,0,0,0.06)',
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      userSelect: 'none',
    },
    headerTitle: {
      fontWeight: 700,
      fontSize: 13,
      letterSpacing: 0.2,
      color: '#111',
    },
    headerRight: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
    },
    iconBtn: {
      color: 'rgba(0,0,0,0.72)',
      '&:hover': { color: 'rgba(0,0,0,0.88)', bgcolor: 'rgba(0,0,0,0.04)' },
    },
    body: {
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    scrollArea: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      scrollbarGutter: 'stable',
    },
    scrollContent: {
      px: 1.5,
      pt: 8,
      pb: 1.5,
      position: 'relative',
    },
    landingColumn: {
      width: '100%',
      maxWidth: 300,
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
    },
    intro: { textAlign: 'center', mt: 3, mb: 2 },
    introTitle: { fontWeight: 700, fontSize: 16, lineHeight: 1.2 },
    introSubtitle: { fontSize: 13, opacity: 0.9 },
    startCard: {
      border: '1px solid rgba(0,0,0,0.08)',
      borderRadius: 2,
      px: 1.25,
      py: 1.1,
      display: 'flex',
      alignItems: 'center',
      bgcolor: '#fff',
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      mb: 1.25,
    },
    plusBox: {
      width: 30,
      height: 30,
      borderRadius: 1.5,
      border: '1px solid #e2e2e2',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#666',
      flexShrink: 0,
    },
    startInput: {
      '& .MuiInputBase-root': { fontSize: 12.5 },
      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
    },
    suggestionCard: {
      width: '100%',
      textAlign: 'left',
      border: '1px solid rgba(0,0,0,0.08)',
      borderRadius: 2,
      px: 1.25,
      py: 1.1,
      bgcolor: '#fff',
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      mb: 1.0,
      justifyContent: 'flex-start',
      fontSize: 12.5,
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.55)',
      textTransform: 'none',
      '&:hover': {
        bgcolor: '#fff',
        borderColor: 'rgba(0,0,0,0.12)',
        boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
      },
    },
    messagesWrap: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      mt: 1,
    },
    bubbleRow: { display: 'flex', width: '100%' },
    bubble: {
      maxWidth: '92%',
      borderRadius: 2,
      border: '1px solid rgba(0,0,0,0.08)',
      px: 1.25,
      py: 1.0,
      fontSize: 12.5,
      lineHeight: 1.35,
      whiteSpace: 'pre-wrap',
      bgcolor: '#fff', // ✅
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    },
    bubbleUser: {
      marginLeft: 'auto',
      bgcolor: '#f4f4f4',
    },
    bubbleAssistant: {
      marginRight: 'auto',
      //normalize markdown typography + spacing
      '& > *:first-of-type': { marginTop: 0 },
      '& > *:last-child': { marginBottom: 0 },
      '& p': {
        margin: '0.25em 0',
      },
      '& h1, & h2, & h3, & h4': {
        margin: '0.35em 0 0.2em',
        fontWeight: 700,
        lineHeight: 1.25,
      },
      '& h1': { fontSize: '1.1em' },
      '& h2': { fontSize: '1.05em' },
      '& h3, & h4': { fontSize: '1.0em' },
      '& ul, & ol': {
        margin: '0.3em 0',
        paddingLeft: '1.2em',
      },
      '& li': {
        margin: '0.15em 0',
      },
      '& li > p': {
        margin: '0.15em 0',
      },
      '& ol': {
        listStylePosition: 'outside',
      },
      '& strong': {
        fontWeight: 700,
      },
      '& blockquote': {
        margin: '0.4em 0',
        paddingLeft: '0.75em',
        borderLeft: '3px solid rgba(0,0,0,0.12)',
        color: 'rgba(0,0,0,0.7)',
      },
      '& pre': {
        margin: '0.4em 0',
        padding: '0.6em 0.7em',
        borderRadius: 8,
        background: 'rgba(0,0,0,0.04)',
        overflowX: 'auto',
      },
      '& code': {
        fontFamily:
          'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        fontSize: '0.95em',
      },
    },
    composer: {
      borderTop: '1px solid rgba(0,0,0,0.08)',
      px: 1.0,
      py: 0.9,
      bgcolor: '#fafafa',
    },
    composerInput: { '& .MuiInputBase-root': { fontSize: 12.5 } },
  };
};
